module.exports = __webpack_public_path__ + "img/banner1.319988c2.jpg";